import {ActivatedRouteSnapshot, DetachedRouteHandle, BaseRouteReuseStrategy, Route} from '@angular/router';

export class AppRouteReuseStrategy implements BaseRouteReuseStrategy {

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    return null;
  }

  public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return curr.routeConfig === null && future.routeConfig === null;
  }

  shouldDestroyInjector(route: Route): boolean {
    return true;
  }

}
